import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.tsx';
import swDev from './swDev';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register Service Worker only for whitelisted PWA domains
try {
  const pwaUrl = [
    'https://axapartners-eu-teleconsultation.axa.travel',
    'https://axapartners-eu-test-teleconsultation.axa.travel',
  ];

  const currentOrigin = window.location.origin;
  console.log('SW Registration - Current origin:', currentOrigin);

  if (Array.isArray(pwaUrl) && pwaUrl.includes(currentOrigin)) {
    console.log('✅ Registering Service Worker for PWA domain');
    swDev();
  } else {
    console.log(
      '❌ Service Worker not registered - domain not in PWA whitelist'
    );
  }
} catch (error) {
  console.error('Error during Service Worker registration check:', error);
}
